module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_WATER_TEMP.978ca4ce.png";